import AppLayout from "../layouts/AppLayout";

export default function PrivacyPolicy() {
    return (
        <AppLayout>
            <div className="w-full">
                <article className="container max-w-dasha mx-auto px-4 sm:px-6 lg:px-8 py-20 pt-0 flex flex-col">
                    <h1 className="text-3xl font-bold mb-4">Privacy Policy</h1>
                    <p className="text-sm text-gray-500 mb-8">Effective Date: July 8, 2025</p>

                    <h2 className="text-xl font-semibold mt-6 mb-2">1. Introduction</h2>
                    <p>PriceHunt.ca ("we", "our", or "us") is committed to protecting your privacy. This Privacy Policy explains how we collect, use, and share information about visitors to our website.</p>

                    <h2 className="text-xl font-semibold mt-6 mb-2">2. Information We Collect</h2>
                    <ul className="list-disc pl-6 space-y-1">
                        <li><strong>Usage Data:</strong> Pages visited, referral sources, time spent on site</li>
                        <li><strong>Device Info:</strong> IP address, browser type, operating system</li>
                        <li><strong>Affiliate Clicks:</strong> Outbound clicks for partner tracking</li>
                        <li><strong>Voluntary Info:</strong> When you contact us or subscribe</li>
                    </ul>

                    <h2 className="text-xl font-semibold mt-6 mb-2">3. How We Use Your Information</h2>
                    <ul className="list-disc pl-6 space-y-1">
                        <li>To analyze and improve website performance</li>
                        <li>To understand visitor behavior</li>
                        <li>To track affiliate commissions</li>
                        <li>To respond to user messages</li>
                    </ul>

                    <h2 className="text-xl font-semibold mt-6 mb-2">4. Cookies and Tracking</h2>
                    <p>We use cookies for analytics, user preferences, and affiliate tracking. You can disable cookies in your browser settings.</p>

                    <h2 className="text-xl font-semibold mt-6 mb-2">5. Third-Party Services</h2>
                    <p>We may share data with services like:</p>
                    <ul className="list-disc pl-6 space-y-1">
                        <li>Google Analytics</li>
                        <li>Amazon Associates</li>
                        <li>BestBuy Affiliate Program</li>
                    </ul>
                    <p>These services may have their own privacy policies.</p>

                    <h2 className="text-xl font-semibold mt-6 mb-2">6. Data Security</h2>
                    <p>We take reasonable steps to secure your information, but no internet transmission is 100% secure.</p>

                    <h2 className="text-xl font-semibold mt-6 mb-2">7. Your Rights</h2>
                    <p>Canadian residents may request access to, correction of, or deletion of their personal data by contacting us.</p>

                    <h2 className="text-xl font-semibold mt-6 mb-2">8. Changes to This Policy</h2>
                    <p>We may update this policy. Any changes will appear on this page with a new effective date.</p>

                    <h2 className="text-xl font-semibold mt-6 mb-2">9. Contact</h2>
                    <p>If you have questions, contact us at:</p>
                    <p className="mt-2 font-medium">privacy@pricehunt.ca</p>
                </article>
            </div >
        </AppLayout >
    )
}